module.exports = __webpack_public_path__ + "static/media/new-to-the-city.bc58164c.svg";